"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMethods = void 0;
var paymentsInBannerByGeo_1 = require("./paymentsInBannerByGeo");
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var useMethods = function () {
    var _a, _b, _c, _d;
    var geoData = (0, swr_hooks_1.useGeo)().data;
    var data = (0, swr_hooks_1.usePublicPayInMethods)(((_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode) || undefined).data;
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        var countryCode = (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode;
        if (!countryCode)
            return;
        var paymentsFromConfig = paymentsInBannerByGeo_1.paymentsInBannerByGeo === null || paymentsInBannerByGeo_1.paymentsInBannerByGeo === void 0 ? void 0 : paymentsInBannerByGeo_1.paymentsInBannerByGeo[countryCode];
        if (!paymentsFromConfig)
            return;
        var paymentsAsObj = paymentsFromConfig.reduce(function (acc, item) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[item] = true, _a)));
        }, {});
        return (_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.payInPublic) === null || _b === void 0 ? void 0 : _b.getMethods) === null || _c === void 0 ? void 0 : _c.edges) === null || _d === void 0 ? void 0 : _d.filter(function (item) { return paymentsAsObj === null || paymentsAsObj === void 0 ? void 0 : paymentsAsObj[(item === null || item === void 0 ? void 0 : item.slug) || '']; });
    }, [(_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode, (_d = (_c = data === null || data === void 0 ? void 0 : data.payInPublic) === null || _c === void 0 ? void 0 : _c.getMethods) === null || _d === void 0 ? void 0 : _d.edges]);
};
exports.useMethods = useMethods;
